export default "__VITE_ASSET__Bg$jBP66__"